import PropTypes from 'prop-types';
import { DefaultWarningIcon } from '@/utils/commonUtils';

import styles from './WarningInformation.module.scss';
import { URLS } from '@/constants/urls';

const WarningInformation = ({ CustomIcon = DefaultWarningIcon, title, children, customClass }) => (
  <div className={`${styles.container}${customClass ? ' ' + customClass : ''}`} data-test-id="warning-information">
    <div className={styles.header}>
      <CustomIcon src={URLS.WARNING_ICON_BLACK} />
      {title && <h5 className={styles.title}>{title}</h5>}
    </div>
    {children && (
      <div className={styles.content}>
        {children}
      </div>
    )}
  </div>
);

WarningInformation.propTypes = {
  CustomIcon: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  customClass: PropTypes.string
};

export default WarningInformation;
